import React, { Component } from "react"
import Image from "../image"
import DarkMode from "./DarkMode"
import { Link } from "gatsby"
import NavLinks from "./navLinks"
import headerStyles from "../../styles/modules/header.module.scss"
import "../../styles/toggle.scss"

class Header extends Component {
  constructor(props) {
    super(props)

    this.state = {
      openMenu: false,
      changeShape: false,
    }
    this.toggleRevealNav = this.toggleRevealNav.bind(this)
  }

  toggleRevealNav() {
    this.setState(prevState => {
      return {
        openMenu: !prevState.openMenu,
        changeShape: !prevState.changeShape,
      }
    })
  }

  render() {
    const { changeShape, openMenu } = this.state
    const shape = changeShape ? `${headerStyles.close}` : `${headerStyles.open}`

    return (
      <header
        id={!openMenu ? headerStyles.header : headerStyles.dropdown}
        className="navbar-expand-lg"
      >
        <div className={headerStyles.title}>
          <div className={headerStyles.logo}>
            <Link to="/">
              <Image />
            </Link>
          </div>
          <div className={headerStyles.info}>
            <h4 className={headerStyles.name}>Fahad Hussain</h4>
            <h4 className={headerStyles.position}>Software Engineer</h4>
          </div>
        </div>

        <DarkMode />
        <NavLinks openMenu={openMenu} toggleRevealNav={this.toggleRevealNav} />

        <div className={shape} onClick={this.toggleRevealNav}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </header>
    )
  }
}
export default Header
